import { Subject } from 'rxjs'
import { CreatePersistentStore, CreateStore } from './types'

export const createStore: CreateStore = <V>(v: V) => {
    let value = v

    const sub = new Subject<V>()

    return {
        value: () => value,
        changes: () => sub,
        change: (v: V) => {
            value = v
            sub.next(v)
        }
    }
}

export const createPersistentStore: CreatePersistentStore = <V>(
    storage: Storage,
    key: string,
    v: V
) => {
    const persisted = storage.getItem(key)
    if (persisted) v = JSON.parse(persisted) as V
    const s = createStore(v)

    s.changes().subscribe(s => {
        storage.setItem(key, JSON.stringify(s))
    })

    return s
}
